import { Box, Center, Loader } from '@hover/blueprint';
import React from 'react';

import { Alert } from 'src/shared/components';
import {
  CanonicalLink as MetaCanonicalLink,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { useUpgradeProfileQuery } from 'src/shared/graphql/generated';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { TwoColumn } from 'src/shared/layouts';
import { Route as Routes } from 'src/shared/route';
import { isNetworkError } from 'src/shared/utils/firebase';

import { UpgradeForm } from './UpgradeForm';

const Upgrade = () => {
  const t = useTranslate(TranslationNamespace.SIGN_UP);
  const { loading, error, data } = useUpgradeProfileQuery();

  const renderContent = () => {
    if (loading || !data) {
      return (
        <Center height="700">
          <Loader size="huge" />
        </Center>
      );
    }

    if (error) {
      return (
        <Alert alignSelf="stretch" flexDirection="row" marginTop={300}>
          {isNetworkError(error)
            ? t('somethingWentWrongTryAgain')
            : t('accountEmailAlreadyExists')}
        </Alert>
      );
    }

    const {
      user: {
        id: userId,
        orgs: [{ id: orgId }],
      },
    } = data.profile;

    return <UpgradeForm orgId={orgId} userId={userId} />;
  };

  return (
    <>
      <MetaCanonicalLink pathname={Routes.SIGN_UP_PROFESSIONAL.path} />
      <MetaTitle title={t('upgrade.upgradeToAProfesionalAccount')} />
      <Box alignItems="center" flexDirection="column" position="relative">
        <TwoColumn.Header
          heading={t('upgrade.upgradeToPro')}
          subheading={t('upgrade.pleaseProvideProAccountDetails')}
        />
        <TwoColumn.Main>{renderContent()}</TwoColumn.Main>
      </Box>
    </>
  );
};

export { Upgrade };
